import {
  get_entries3tl980hg1b2bm as get_entries,
  Parent27xjh1mdkxxuk as Parent,
  Family2k7vz7ddyergb as Family,
  IncomeRangeprzolg293f44 as IncomeRange,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { Cents1lsbs5l1tlgw as Cents } from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import {
  get_stringsy7vodl9dj0ya as get_strings,
  StringsForLanguage_English_getInstance2jm5ip12elsyk as StringsForLanguage_English_getInstance,
} from '../../strings.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_firstName3blaveac0mrqf as get_firstName,
  get_lastName3bf5kvm2i63yd as get_lastName,
  get_gender1ue2tducd3zez as get_gender,
  get_birthDate2r259t5gzdpld as get_birthDate,
  get_phone27h5zus6ceaut as get_phone,
  get_alternatePhone3s5tf4bybwvr0 as get_alternatePhone,
  get_email2vebsqfvcm8pu as get_email,
  get_preferredLanguage1xl103nz1xya4 as get_preferredLanguage,
  get_race1qlprp2znhxws as get_race,
  get_line12qowz8aajkggm as get_line1,
  get_line22yru7ztqlgmow as get_line2,
  get_city182djzl8rp5cw as get_city,
  get_state1oesqq81882tl as get_state,
  get_postalCodeb3j2izx1u631 as get_postalCode,
  get_primaryParent1y63p7tb3kpdx as get_primaryParent,
  get_secondaryParent11vqc6r832a2n as get_secondaryParent,
  get_address2uhm0456nbriz as get_address,
  get_familySize3udi93tkuiabd as get_familySize,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { lensPath21i5dxhjzuxep as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { assertReactive22ewziiekbth5 as assertReactive } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/reactiveHelpers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  LabeledViewseav57tyecmf as LabeledView,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { validatedmmpm5lnzq3lm as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import {
  withStringBuffer3khj76irczpue as withStringBuffer,
  withStringBufferw9sv07w4j3wo as withStringBuffer_0,
} from '../components/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  get_entries3daovqa75g4uq as get_entries_0,
  Addresspdncepxooezp as Address,
  get_entries1h5lbabcw0nnn as get_entries_1,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import {
  toList3jhuyej2anx2q as toList,
  plus310ted5e4i90h as plus,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  contains3hkd7li7hrfjb as contains,
  notNull1cr24slx2d4vw as notNull,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import {
  labeledCheckbox1ycivizfzdk0y as labeledCheckbox,
  labeledCheckbox2i8m4uxe4r9p8 as labeledCheckbox_0,
  reactiveLabel206b3aonybuoa as reactiveLabel,
  maybeLabel2ow5e5yzodgn0 as maybeLabel,
} from '../components/view-utilities.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import { rangeTo5xinnemk0fd3 as rangeTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  PhoneNumber__toString_impl_7i2x3q2my82bpxyutrq as PhoneNumber__toString_impl_7i2x3q,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_displayName(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = get_entries();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp;
      var tmp_0 = _this__u8e3s4.min_1;
      if (equals(new (Cents())(element.min_1), tmp_0 == null ? null : new (Cents())(tmp_0))) {
        var tmp_1 = element.max_1;
        var tmp_2 = tmp_1 == null ? null : new (Cents())(tmp_1);
        var tmp_3 = _this__u8e3s4.max_1;
        tmp = equals(tmp_2, tmp_3 == null ? null : new (Cents())(tmp_3));
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.displayName_1;
  var tmp_4;
  if (tmp1_elvis_lhs == null) {
    var tmp2_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(get_strings(AppState_getInstance()).get_state_wc71uu_k$());
    tmp_4 = (tmp2_elvis_lhs == null ? StringsForLanguage_English_getInstance() : tmp2_elvis_lhs).get_familyPreferNotToSayLabel_t7jcq_k$();
  } else {
    tmp_4 = tmp1_elvis_lhs;
  }
  return tmp_4;
}
function parentForm(form, _this__u8e3s4, parent, showSecondParent, primary, lockEmail) {
  primary = primary === VOID ? true : primary;
  lockEmail = lockEmail === VOID ? false : lockEmail;
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp = weight(element_0, 1.0);
  var tmp_0 = parentForm$lambda;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Parent()), arrayOf([]), false));
  var tmp$ret$13 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$13);
  var tmp$ret$14 = get_firstName(it);
  var tmp_2 = lensPath(parent, tmp$ret$14);
  form.stringField$default_pwglgw_k$(tmp, tmp_0, assertReactive(tmp_2, 'Cannot be blank', VOID, VOID, ($this$assertReactive, it) => !(isBlank(it) && (primary || $this$assertReactive.invoke_r7m7el_k$(showSecondParent)))), true);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp_3 = weight(element_0, 1.0);
  var tmp_4 = parentForm$lambda_0;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_5 = serializerOrContextual(createKType(getKClass(Parent()), arrayOf([]), false));
  var tmp$ret$18 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$18);
  var tmp$ret$19 = get_lastName(it_0);
  var tmp_6 = lensPath(parent, tmp$ret$19);
  form.stringField$default_pwglgw_k$(tmp_3, tmp_4, assertReactive(tmp_6, 'Cannot be blank', VOID, VOID, ($this$assertReactive, it) => !(isBlank(it) && (primary || $this$assertReactive.invoke_r7m7el_k$(showSecondParent)))), true);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  var tmp_7 = parentForm$lambda_1;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_8 = serializerOrContextual(createKType(getKClass(Parent()), arrayOf([]), false));
  var tmp$ret$22 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$22);
  var tmp$ret$23 = get_gender(it_1);
  var tmp_9 = lensPath(parent, tmp$ret$23);
  var tmp_10 = remember(VOID, VOID, VOID, VOID, parentForm$lambda_2);
  form.selectField_qav2qe_k$(element, tmp_7, tmp_9, tmp_10, false, parentForm$lambda_3);
  var tmp_11 = parentForm$lambda_4;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_12 = serializerOrContextual(createKType(getKClass(Parent()), arrayOf([]), false));
  var tmp$ret$26 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$26);
  var tmp$ret$27 = get_birthDate(it_2);
  var tmp$ret$24 = lensPath(parent, tmp$ret$27);
  form.dateField$default_ksnshl_k$(element, tmp_11, tmp$ret$24, false);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_0 = weight(element_1, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_0.willAddChild_hz2iwc_k$(element_2);
  var tmp_13 = KMutableProperty0();
  var tmp_14 = LabeledView$_get_content_$ref_5yojet(element_2);
  var tmp_15 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, LabeledView$_set_content_$ref_ys1c8f(element_2));
  element_2.invoke_bnq13k_k$(tmp_15, parentForm$lambda_5);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
  var this_1 = themed(element_2, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = PhoneNumberInput().new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_w1yrw4_k$(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_1.willAddChild_hz2iwc_k$(element_3);
  var tmp_16 = element_3.get_content_h02jrk_k$();
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_17 = serializerOrContextual(createKType(getKClass(Parent()), arrayOf([]), false));
  var tmp$ret$42 = isInterface(tmp_17, KSerializer()) ? tmp_17 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$42);
  var tmp$ret$43 = get_phone(it_3);
  var tmp$ret$40 = lensPath(parent, tmp$ret$43);
  element_3.bind_gesskf_k$(tmp_16, withStringBuffer(validated(tmp$ret$40)));
  element_3.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_3);
  element_2.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_2 = weight(element_1, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_2.willAddChild_hz2iwc_k$(element_4);
  var tmp_18 = KMutableProperty0();
  var tmp_19 = LabeledView$_get_content_$ref_5yojet(element_4);
  var tmp_20 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, LabeledView$_set_content_$ref_ys1c8f(element_4));
  element_4.invoke_bnq13k_k$(tmp_20, parentForm$lambda_6);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
  var this_3 = themed(element_4, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = PhoneNumberInput().new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_w1yrw4_k$(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  this_3.willAddChild_hz2iwc_k$(element_5);
  var tmp_21 = element_5.get_content_h02jrk_k$();
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_22 = serializerOrContextual(createKType(getKClass(Parent()), arrayOf([]), false));
  var tmp$ret$54 = isInterface(tmp_22, KSerializer()) ? tmp_22 : THROW_CCE();
  var it_4 = new (DataClassPathSelf())(tmp$ret$54);
  var tmp$ret$55 = get_alternatePhone(it_4);
  var tmp$ret$52 = lensPath(parent, tmp$ret$55);
  element_5.bind_gesskf_k$(tmp_21, withStringBuffer(validated(tmp$ret$52)));
  element_5.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_5);
  element_4.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_4);
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  element.willAddChild_hz2iwc_k$(element_6);
  var tmp_23 = KMutableProperty0();
  var tmp_24 = LabeledView$_get_content_$ref_5yojet(element_6);
  var tmp_25 = getPropertyCallableRef('content', 0, tmp_23, tmp_24, LabeledView$_set_content_$ref_ys1c8f(element_6));
  element_6.invoke_bnq13k_k$(tmp_25, parentForm$lambda_7);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_4 = themed(element_6, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_7 = new (TextInput())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_7);
  this_4.willAddChild_hz2iwc_k$(element_7);
  var tmp_26 = KMutableProperty0();
  var tmp_27 = TextInput$_get_enabled_$ref_3dkh3c(element_7);
  var tmp_28 = getPropertyCallableRef('enabled', 0, tmp_26, tmp_27, TextInput$_set_enabled_$ref_xnynf8(element_7));
  element_7.invoke_bnq13k_k$(tmp_28, ($this$invoke) => !lockEmail);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_29 = serializerOrContextual(createKType(getKClass(Parent()), arrayOf([]), false));
  var tmp$ret$65 = isInterface(tmp_29, KSerializer()) ? tmp_29 : THROW_CCE();
  var it_5 = new (DataClassPathSelf())(tmp$ret$65);
  var tmp$ret$66 = get_email(it_5);
  var tmp$ret$63 = lensPath(parent, tmp$ret$66);
  element_7.bind_gesskf_k$(element_7.content_1, withStringBuffer_0(validated(tmp$ret$63)));
  element_7.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_7);
  element_6.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_6);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_8 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
  ensureOutermostElement(element_8);
  element.willAddChild_hz2iwc_k$(element_8);
  var tmp_30 = KMutableProperty0();
  var tmp_31 = LabeledView$_get_content_$ref_5yojet(element_8);
  var tmp_32 = getPropertyCallableRef('content', 0, tmp_30, tmp_31, LabeledView$_set_content_$ref_ys1c8f(element_8));
  element_8.invoke_bnq13k_k$(tmp_32, parentForm$lambda_8);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_5 = themed(element_8, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_9 = new (TextInput())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_9);
  this_5.willAddChild_hz2iwc_k$(element_9);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_33 = serializerOrContextual(createKType(getKClass(Parent()), arrayOf([]), false));
  var tmp$ret$76 = isInterface(tmp_33, KSerializer()) ? tmp_33 : THROW_CCE();
  var it_6 = new (DataClassPathSelf())(tmp$ret$76);
  var tmp$ret$77 = get_preferredLanguage(it_6);
  var tmp$ret$74 = lensPath(parent, tmp$ret$77);
  element_9.bind_gesskf_k$(element_9.content_1, tmp$ret$74);
  element_9.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_9);
  element_8.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_8);
  // Inline function 'com.lightningkite.kiteui.views.compact' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_6 = themed(element, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_10 = new (RowOrCol())(this_6.get_context_h02k06_k$());
  ensureOutermostElement(element_10);
  this_6.willAddChild_hz2iwc_k$(element_10);
  element_10.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_7 = themed(element_10, LabelSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_11 = new (TextView())(this_7.get_context_h02k06_k$());
  ensureOutermostElement(element_11);
  this_7.willAddChild_hz2iwc_k$(element_11);
  var tmp_34 = KMutableProperty0();
  var tmp_35 = TextView$_get_content_$ref_4pzcwl(element_11);
  var tmp_36 = getPropertyCallableRef('content', 0, tmp_34, tmp_35, TextView$_set_content_$ref_pketfb(element_11));
  element_11.invoke_bnq13k_k$(tmp_36, parentForm$lambda_9);
  element_11.onStartup_vrxh3i_k$();
  this_7.addChild_2qpft2_k$(element_11);
  var _iterator__ex2g4s = toList(get_entries_0()).iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'com.lightningkite.serialization.lensPath' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_37 = serializerOrContextual(createKType(getKClass(Parent()), arrayOf([]), false));
    var tmp$ret$88 = isInterface(tmp_37, KSerializer()) ? tmp_37 : THROW_CCE();
    var it_7 = new (DataClassPathSelf())(tmp$ret$88);
    var tmp$ret$89 = get_race(it_7);
    var tmp$ret$86 = lensPath(parent, tmp$ret$89);
    labeledCheckbox(element_10, item.displayName_1, contains(tmp$ret$86, item));
  }
  element_10.onStartup_vrxh3i_k$();
  this_6.addChild_2qpft2_k$(element_10);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function addressForm(form, _this__u8e3s4, address) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = LabeledView$_get_content_$ref_5yojet(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, LabeledView$_set_content_$ref_ys1c8f(element));
  element.invoke_bnq13k_k$(tmp_1, addressForm$lambda);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_0 = themed(element, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextInput())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$11 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$11);
  var tmp$ret$12 = get_line1(it);
  var tmp$ret$9 = lensPath(address, tmp$ret$12);
  element_0.bind_gesskf_k$(element_0.content_1, tmp$ret$9);
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element_1);
  var tmp_3 = KMutableProperty0();
  var tmp_4 = LabeledView$_get_content_$ref_5yojet(element_1);
  var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, LabeledView$_set_content_$ref_ys1c8f(element_1));
  element_1.invoke_bnq13k_k$(tmp_5, addressForm$lambda_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_1 = themed(element_1, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextInput())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_6 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$22 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$22);
  var tmp$ret$23 = get_line2(it_0);
  var tmp$ret$20 = lensPath(address, tmp$ret$23);
  element_2.bind_gesskf_k$(element_2.content_1, tmp$ret$20);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  element_1.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element_3);
  var tmp_7 = KMutableProperty0();
  var tmp_8 = LabeledView$_get_content_$ref_5yojet(element_3);
  var tmp_9 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, LabeledView$_set_content_$ref_ys1c8f(element_3));
  element_3.invoke_bnq13k_k$(tmp_9, addressForm$lambda_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_2 = themed(element_3, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextInput())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_2.willAddChild_hz2iwc_k$(element_4);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_10 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$33 = isInterface(tmp_10, KSerializer()) ? tmp_10 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$33);
  var tmp$ret$34 = get_city(it_1);
  var tmp$ret$31 = lensPath(address, tmp$ret$34);
  element_4.bind_gesskf_k$(element_4.content_1, tmp$ret$31);
  element_4.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_4);
  element_3.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element_5);
  element_5.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_3 = weight(element_5, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  this_3.willAddChild_hz2iwc_k$(element_6);
  var tmp_11 = KMutableProperty0();
  var tmp_12 = LabeledView$_get_content_$ref_5yojet(element_6);
  var tmp_13 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, LabeledView$_set_content_$ref_ys1c8f(element_6));
  element_6.invoke_bnq13k_k$(tmp_13, addressForm$lambda_2);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_4 = themed(element_6, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_7 = new (TextInput())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_7);
  this_4.willAddChild_hz2iwc_k$(element_7);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_14 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$49 = isInterface(tmp_14, KSerializer()) ? tmp_14 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$49);
  var tmp$ret$50 = get_state(it_2);
  var tmp$ret$47 = lensPath(address, tmp$ret$50);
  element_7.bind_gesskf_k$(element_7.content_1, tmp$ret$47);
  element_7.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_7);
  element_6.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_6);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_5 = weight(element_5, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_8 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_8);
  this_5.willAddChild_hz2iwc_k$(element_8);
  var tmp_15 = KMutableProperty0();
  var tmp_16 = LabeledView$_get_content_$ref_5yojet(element_8);
  var tmp_17 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, LabeledView$_set_content_$ref_ys1c8f(element_8));
  element_8.invoke_bnq13k_k$(tmp_17, addressForm$lambda_3);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_6 = themed(element_8, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_9 = new (TextInput())(this_6.get_context_h02k06_k$());
  ensureOutermostElement(element_9);
  this_6.willAddChild_hz2iwc_k$(element_9);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_18 = serializerOrContextual(createKType(getKClass(Address()), arrayOf([]), false));
  var tmp$ret$61 = isInterface(tmp_18, KSerializer()) ? tmp_18 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$61);
  var tmp$ret$62 = get_postalCode(it_3);
  var tmp$ret$59 = lensPath(address, tmp$ret$62);
  element_9.bind_gesskf_k$(element_9.content_1, tmp$ret$59);
  element_9.onStartup_vrxh3i_k$();
  this_6.addChild_2qpft2_k$(element_9);
  element_8.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_8);
  element_5.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element_5);
  return element_5;
}
function familyForm(form, _this__u8e3s4, family, showSecondParent, lockPrimaryEmail) {
  lockPrimaryEmail = lockPrimaryEmail === VOID ? false : lockPrimaryEmail;
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  var tmp0_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(get_strings(AppState_getInstance()).get_state_wc71uu_k$());
  var strings = tmp0_elvis_lhs == null ? StringsForLanguage_English_getInstance() : tmp0_elvis_lhs;
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(element, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, familyForm$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$18 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$18);
  var tmp$ret$19 = get_primaryParent(it);
  var tmp$ret$16 = lensPath(family, tmp$ret$19);
  parentForm(form, element_0, tmp$ret$16, showSecondParent, true, lockPrimaryEmail);
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_1 = themed(element, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (TextView())(element_2.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  element_2.willAddChild_hz2iwc_k$(element_3);
  element_3.set_themeChoice_py59um_k$(element_3.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_3);
  var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_3));
  element_3.invoke_bnq13k_k$(tmp_5, familyForm$lambda_0);
  element_3.onStartup_vrxh3i_k$();
  element_2.addChild_2qpft2_k$(element_3);
  labeledCheckbox_0(element_2, familyForm$lambda_1, showSecondParent);
  var tmp_6 = shownWhen(element_2, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(showSecondParent));
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_7 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$32 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$32);
  var tmp$ret$33 = get_secondaryParent(it_0);
  var tmp$ret$30 = lensPath(family, tmp$ret$33);
  parentForm(form, tmp_6, validated(notNull(tmp$ret$30, new (Parent())('', ''))), showSecondParent, false);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_2 = themed(element, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (RowOrCol())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_2.willAddChild_hz2iwc_k$(element_4);
  element_4.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (TextView())(element_4.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  element_4.willAddChild_hz2iwc_k$(element_5);
  element_5.set_themeChoice_py59um_k$(element_5.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp_8 = KMutableProperty0();
  var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_5);
  var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_5));
  element_5.invoke_bnq13k_k$(tmp_10, familyForm$lambda_2);
  element_5.onStartup_vrxh3i_k$();
  element_4.addChild_2qpft2_k$(element_5);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_11 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$46 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$46);
  var tmp$ret$47 = get_address(it_1);
  var tmp$ret$44 = lensPath(family, tmp$ret$47);
  addressForm(form, element_4, tmp$ret$44);
  element_4.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_4);
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_3 = themed(element, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (RowOrCol())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  this_3.willAddChild_hz2iwc_k$(element_6);
  element_6.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
  ensureOutermostElement(element_7);
  element_6.willAddChild_hz2iwc_k$(element_7);
  element_7.set_themeChoice_py59um_k$(element_7.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp_12 = KMutableProperty0();
  var tmp_13 = TextView$_get_content_$ref_4pzcwl(element_7);
  var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb(element_7));
  element_7.invoke_bnq13k_k$(tmp_14, familyForm$lambda_3);
  element_7.onStartup_vrxh3i_k$();
  element_6.addChild_2qpft2_k$(element_7);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_8 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_6.get_context_h02k06_k$());
  ensureOutermostElement(element_8);
  element_6.willAddChild_hz2iwc_k$(element_8);
  var tmp_15 = KMutableProperty0();
  var tmp_16 = LabeledView$_get_content_$ref_5yojet(element_8);
  var tmp_17 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, LabeledView$_set_content_$ref_ys1c8f(element_8));
  element_8.invoke_bnq13k_k$(tmp_17, familyForm$lambda_4);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  var this_4 = themed(element_8, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_9 = new (Select())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_9);
  this_4.willAddChild_hz2iwc_k$(element_9);
  var tmp_18 = familyForm$lambda_5;
  var tmp_19 = family.lens_u4wb4z_k$(tmp_18, familyForm$lambda_6);
  var tmp_20 = _Constant___init__impl__v45mub(plus(listOf(null), toList(get_entries())));
  element_9.bind_64a41i_k$(tmp_19, new (Constant())(tmp_20), (it) => {
    var tmp1_elvis_lhs = it == null ? null : it.displayName_1;
    return tmp1_elvis_lhs == null ? strings.get_familyPreferNotToSayLabel_t7jcq_k$() : tmp1_elvis_lhs;
  });
  element_9.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_9);
  element_8.onStartup_vrxh3i_k$();
  element_6.addChild_2qpft2_k$(element_8);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_10 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_6.get_context_h02k06_k$());
  ensureOutermostElement(element_10);
  element_6.willAddChild_hz2iwc_k$(element_10);
  var tmp_21 = KMutableProperty0();
  var tmp_22 = LabeledView$_get_content_$ref_5yojet(element_10);
  var tmp_23 = getPropertyCallableRef('content', 0, tmp_21, tmp_22, LabeledView$_set_content_$ref_ys1c8f(element_10));
  element_10.invoke_bnq13k_k$(tmp_23, familyForm$lambda_7);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  var this_5 = themed(element_10, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_11 = new (NumberInput())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_11);
  this_5.willAddChild_hz2iwc_k$(element_11);
  element_11.set_range_a3mq0h_k$(rangeTo(1.0, 100.0));
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_24 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$74 = isInterface(tmp_24, KSerializer()) ? tmp_24 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$74);
  var tmp$ret$75 = get_familySize(it_2);
  var tmp_25 = lensPath(family, tmp$ret$75);
  var tmp_26 = familyForm$lambda_8;
  element_11.bind_gesskf_k$(element_11.content_1, tmp_25.lens_drj4fu_k$(tmp_26, familyForm$lambda_9));
  element_11.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_11);
  element_10.onStartup_vrxh3i_k$();
  element_6.addChild_2qpft2_k$(element_10);
  element_6.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_6);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function familyDetails(_this__u8e3s4, family, showVerified) {
  showVerified = showVerified === VOID ? false : showVerified;
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_rem(50);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowCollapsingToColumn())(_this__u8e3s4.get_context_h02k06_k$(), listOf(new (Dimension())(breakpoint)));
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  var tmp = familyDetails$lambda;
  reactiveLabel(element_0, tmp, ($this$reactiveLabel) => $this$reactiveLabel.invoke_r7m7el_k$(family).primaryParent_1.get_fullName_9skygt_k$());
  var tmp_0 = familyDetails$lambda_0;
  maybeLabel(element_0, tmp_0, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).primaryParent_1.email_1;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new (EmailAddress())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = EmailAddress__toString_impl_artjh3(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  var tmp_1 = familyDetails$lambda_1;
  maybeLabel(element_0, tmp_1, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).primaryParent_1.gender_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.displayName_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  var tmp_2 = familyDetails$lambda_2;
  maybeLabel(element_0, tmp_2, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).primaryParent_1.birthDate_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  var tmp_3 = familyDetails$lambda_3;
  maybeLabel(element_0, tmp_3, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).primaryParent_1.phone_1;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = PhoneNumber__toString_impl_7i2x3q(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  var tmp_4 = familyDetails$lambda_4;
  maybeLabel(element_0, tmp_4, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).primaryParent_1.alternatePhone_1;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = PhoneNumber__toString_impl_7i2x3q(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  var tmp_5 = familyDetails$lambda_5;
  maybeLabel(element_0, tmp_5, ($this$maybeLabel) => {
    var tmp = $this$maybeLabel.invoke_r7m7el_k$(family).primaryParent_1.race_1;
    return joinToString(tmp, ', ', VOID, VOID, VOID, VOID, familyDetails$lambda$lambda);
  });
  var tmp_6 = familyDetails$lambda_6;
  maybeLabel(element_0, tmp_6, ($this$maybeLabel) => $this$maybeLabel.invoke_r7m7el_k$(family).primaryParent_1.preferredLanguage_1);
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (Separator())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp_7 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_1 = shownWhen(tmp_7, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(family).secondaryParent_1 == null));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.set_vertical_nuap32_k$(true);
  var tmp_8 = familyDetails$lambda_7;
  maybeLabel(element_2, tmp_8, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).secondaryParent_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_fullName_9skygt_k$();
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  var tmp_9 = familyDetails$lambda_8;
  maybeLabel(element_2, tmp_9, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).secondaryParent_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.email_1;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new (EmailAddress())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = EmailAddress__toString_impl_artjh3(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  });
  var tmp_10 = familyDetails$lambda_9;
  maybeLabel(element_2, tmp_10, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).secondaryParent_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gender_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.displayName_1;
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  });
  var tmp_11 = familyDetails$lambda_10;
  maybeLabel(element_2, tmp_11, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).secondaryParent_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.birthDate_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : renderToString(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  });
  var tmp_12 = familyDetails$lambda_11;
  maybeLabel(element_2, tmp_12, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).secondaryParent_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.phone_1;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = PhoneNumber__toString_impl_7i2x3q(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  });
  var tmp_13 = familyDetails$lambda_12;
  maybeLabel(element_2, tmp_13, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).secondaryParent_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.alternatePhone_1;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = PhoneNumber__toString_impl_7i2x3q(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  });
  var tmp_14 = familyDetails$lambda_13;
  maybeLabel(element_2, tmp_14, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).secondaryParent_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.race_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = joinToString(tmp1_safe_receiver, ', ', VOID, VOID, VOID, VOID, familyDetails$lambda$lambda_0);
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  });
  var tmp_15 = familyDetails$lambda_14;
  maybeLabel(element_2, tmp_15, ($this$maybeLabel) => {
    var tmp0_safe_receiver = $this$maybeLabel.invoke_r7m7el_k$(family).secondaryParent_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.preferredLanguage_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  var this_2 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(family).secondaryParent_1 == null));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Separator())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_2.willAddChild_hz2iwc_k$(element_3);
  element_3.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_3 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (RowOrCol())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_3.willAddChild_hz2iwc_k$(element_4);
  element_4.set_vertical_nuap32_k$(true);
  var tmp_16 = familyDetails$lambda_15;
  maybeLabel(element_4, tmp_16, ($this$maybeLabel) => $this$maybeLabel.invoke_r7m7el_k$(family).address_1.toString());
  var tmp_17 = familyDetails$lambda_16;
  reactiveLabel(element_4, tmp_17, ($this$reactiveLabel) => get_displayName($this$reactiveLabel.invoke_r7m7el_k$(family).income_1));
  if (showVerified) {
    var tmp_18 = familyDetails$lambda_17;
    reactiveLabel(element_4, tmp_18, ($this$reactiveLabel) => {
      var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(family).informationVerifiedAt_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString(tmp0_safe_receiver);
      return tmp1_elvis_lhs == null ? $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyNotVerifiedLabel_31381m_k$() : tmp1_elvis_lhs;
    });
  }
  element_4.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_4);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
}
function parentForm$lambda($this$stringField) {
  return $this$stringField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyFirstNameLabel_j5nup2_k$();
}
function parentForm$lambda_0($this$stringField) {
  return $this$stringField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyLastNameLabel_slk1mi_k$();
}
function parentForm$lambda_1($this$selectField) {
  return 'Gender';
}
function parentForm$lambda_2($this$remember) {
  return plus(listOf(null), toList(get_entries_1()));
}
function parentForm$lambda_3(it) {
  var tmp1_elvis_lhs = it == null ? null : it.displayName_1;
  return tmp1_elvis_lhs == null ? 'Not selected' : tmp1_elvis_lhs;
}
function parentForm$lambda_4($this$dateField) {
  return 'Birthdate';
}
function parentForm$lambda_5($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyPhoneNumberLabel_28h2zu_k$();
}
function parentForm$lambda_6($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAlternatePhoneLabel_sqbdsj_k$();
}
function parentForm$lambda_7($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyEmailLabel_ow4s1n_k$();
}
function TextInput$_get_enabled_$ref_3dkh3c(p0) {
  return constructCallableReference(() => p0.get_enabled_pcr8o8_k$(), 0, 0, 204, VOID, [p0]);
}
function TextInput$_set_enabled_$ref_xnynf8(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_enabled_tswf75_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 205, VOID, [p0]);
}
function parentForm$lambda_8($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyPreferredLanguageLabel_sqcw94_k$();
}
function parentForm$lambda_9($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyRaceEthnicityLabel_z00d2r_k$();
}
function addressForm$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyStreetAddressLabel_hc5wvk_k$();
}
function addressForm$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAptSuiteLabel_c6ev78_k$();
}
function addressForm$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyCityLabel_9p20yk_k$();
}
function addressForm$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyStateLabel_kkdf00_k$();
}
function addressForm$lambda_3($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyZipcodeLabel_v3fgfh_k$();
}
function familyForm$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyPrimaryParentLabel_xb85ed_k$();
}
function familyForm$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familySecondaryParentLabel_xd744d_k$();
}
function familyForm$lambda_1($this$labeledCheckbox) {
  return $this$labeledCheckbox.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAddSecondParentLabel_6zuz7m_k$();
}
function familyForm$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAddressLabel_jhvmgd_k$();
}
function familyForm$lambda_3($this$invoke) {
  return 'Additional info';
}
function familyForm$lambda_4($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAnnualIncomeLabel_nsky2p_k$();
}
function familyForm$lambda_5(it) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = get_entries();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp;
      var tmp_0 = it.income_1.min_1;
      if (equals(new (Cents())(element.min_1), tmp_0 == null ? null : new (Cents())(tmp_0))) {
        var tmp_1 = element.max_1;
        var tmp_2 = tmp_1 == null ? null : new (Cents())(tmp_1);
        var tmp_3 = it.income_1.max_1;
        tmp = equals(tmp_2, tmp_3 == null ? null : new (Cents())(tmp_3));
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function familyForm$lambda_6(old, new_0) {
  var tmp = new_0 == null ? null : new_0.min_1;
  return old.copy$default_8deers_k$(VOID, VOID, VOID, VOID, VOID, new (IncomeRange())(tmp, new_0 == null ? null : new_0.max_1));
}
function familyForm$lambda_7($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familySizeLabel_ytosca_k$();
}
function familyForm$lambda_8(it) {
  return it == null ? null : it;
}
function familyForm$lambda_9(it) {
  return it == null ? null : numberToInt(it);
}
function familyDetails$lambda($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyPrimaryParentLabel_xb85ed_k$();
}
function familyDetails$lambda_0($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyPrimaryEmailLabel_sxbo19_k$();
}
function familyDetails$lambda_1($this$maybeLabel) {
  return 'Gender';
}
function familyDetails$lambda_2($this$maybeLabel) {
  return 'Birthdate';
}
function familyDetails$lambda_3($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyPrimaryPhoneLabel_n1pnad_k$();
}
function familyDetails$lambda_4($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyPrimaryAlternatePhoneLabel_l533dh_k$();
}
function familyDetails$lambda_5($this$maybeLabel) {
  return 'Race/ethnicity';
}
function familyDetails$lambda$lambda(it) {
  return it.displayName_1;
}
function familyDetails$lambda_6($this$maybeLabel) {
  return 'Preferred language';
}
function familyDetails$lambda_7($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familySecondaryParentLabel_xd744d_k$();
}
function familyDetails$lambda_8($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familySecondaryEmailLabel_1kj0yn_k$();
}
function familyDetails$lambda_9($this$maybeLabel) {
  return 'Gender';
}
function familyDetails$lambda_10($this$maybeLabel) {
  return 'Birthdate';
}
function familyDetails$lambda_11($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familySecondaryPhoneLabel_kmlrm5_k$();
}
function familyDetails$lambda_12($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familySecondaryAlternatePhoneLabel_rncxqf_k$();
}
function familyDetails$lambda_13($this$maybeLabel) {
  return 'Race/ethnicity';
}
function familyDetails$lambda$lambda_0(it) {
  return it.displayName_1;
}
function familyDetails$lambda_14($this$maybeLabel) {
  return 'Preferred language';
}
function familyDetails$lambda_15($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAddressLabel_jhvmgd_k$();
}
function familyDetails$lambda_16($this$reactiveLabel) {
  return 'Income';
}
function familyDetails$lambda_17($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyInformationVerifiedLabel_5tuhwz_k$();
}
//region block: exports
export {
  familyDetails as familyDetails18tkj8l8txyir,
  familyForm as familyForm1exz237lcn7kd,
};
//endregion

//# sourceMappingURL=familyComponents.mjs.map
